import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=00caf1c3"
import script from "./AreaSelect.vue?vue&type=script&lang=js"
export * from "./AreaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports